import { ThemeProvider } from '@ui';
import React from 'react';
import { Login } from '../auth/Login';
import { Footer } from '../common/Footer';
import { GalleryEditorContext, GallerySharedContext } from '../gallery/GalleryContext';
import { GalleryView } from '../gallery/GalleryView';
import { Invoices } from '../invoice/Invoices';
import { LicenseAssignment } from '../license-assignment/LicenseAssignment';
import { TopMenu } from '../page/TopMenu';
import { SubscriptionView } from '../subscriptions/SubscriptionView';
import { NoSubscriptions } from '../subscriptions/NoSubscriptions';
import { DailySurvey } from '../survey/DailySurvey';
import { UploadManagement } from '../upload-management/UploadManagement';
import {
  UploadManagementContextFromGuid,
  UploadManagementContextFromSharedContent,
} from '../upload-management/UploadManagementContext';
import { UserManagement } from '../user-management';
import { WebshopProvider } from '../webshop';
import { ModuleName, ModuleProps } from './types';

export const modulePaths: Record<ModuleName, React.FunctionComponent<Omit<ModuleProps, 'path'>>> = {
  userManagement: UserManagement,
  licenseAssignment: ({ data }) => <LicenseAssignment licenseData={data} />,
  galleryEditor: ({ params }) => (
    <GalleryEditorContext viewMode='edit' galleryId={params.galleryId}>
      <GalleryView />
    </GalleryEditorContext>
  ),
  galleryReader: ({ params }) => (
    <GalleryEditorContext galleryId={params.galleryId} viewMode='read'>
      <GalleryView />
    </GalleryEditorContext>
  ),
  galleryShared: ({ params }) => (
    <GallerySharedContext {...params}>
      <GalleryView />
    </GallerySharedContext>
  ),
  uploadManagement: ({ params }) => (
    <UploadManagementContextFromGuid {...params}>
      <UploadManagement />
    </UploadManagementContextFromGuid>
  ),
  uploadManagementSharedContent: ({ params }) => (
    <UploadManagementContextFromSharedContent {...params}>
      <UploadManagement />
    </UploadManagementContextFromSharedContent>
  ),
  login: () => <Login />,
  invoices: () => (
    <WebshopProvider>
      <Invoices />
    </WebshopProvider>
  ),
  survey: ({ params }) => (
    <DailySurvey
      ratePlan={params.ratePlan}
      subscription={params.subscription}
      onComplete={params.onComplete}
    />
  ),
  subscription: () => (
    <ThemeProvider>
      <WebshopProvider>
        <SubscriptionView />
      </WebshopProvider>
    </ThemeProvider>
  ),
  footer: () => <Footer />,
  topMenu: TopMenu,
  noSubscriptions: () => (
    <ThemeProvider>
      <WebshopProvider>
        <NoSubscriptions />
      </WebshopProvider>
    </ThemeProvider>
  ),
  oldSubscriptions: () => null,
  paymentMethod: () => null,
  billingInformation: () => null,
};
